import React, {Component} from 'react'
import {Button, ButtonGroup, Modal, ModalBody, ModalHeader, Row, Form, ModalFooter} from 'reactstrap'
import PropTypes from 'prop-types'
import {graphql, withApollo} from 'react-apollo'
import _ from 'lodash'
import {CreateFinalReport} from '../Projects/final_report/mutations'
import {GET_JOBS} from '../JobsNotifications/graphql'
import Step2ColumnSelection from './Step2ColumnSelection'
import Step3ReportSettings from './Step3ReportSettings'
import Step1ElementSelection from './Step1ElementSelection'

const formats = [
  {name: 'PDF - Portable Document Format', value: 'pdf'}, 
  {name: 'CSV - Comma-Separated Values', value: 'csv'},
  {name: 'XSLX - Excel Open XML Spreadsheet', value: 'xslx'}
]

class FinalReportModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentStep: 1,
      selectedElements: [],
      selected_columns: [],
      selected_attachments: [],
      selected_exclusions: [],
      versions: [
        {name: 'Column', value: 'final_column', formats: formats}
      ],
      version: 'final_column',
      format: 'pdf',
      templates: JSON.parse(localStorage.getItem('finalReportTemplates')) || {},
      template_name: '',
    }
  }

  static propTypes = {
    mutate: PropTypes.func.isRequired,
    toggleFunction: PropTypes.func.isRequired,
    projectId: PropTypes.number.isRequired,
    selectedWeldIds: PropTypes.array,
    client: PropTypes.object.isRequired
  }

  nextStep = () => {
    if (this.state.currentStep < 3) {
      this.setState({ currentStep: this.state.currentStep + 1 })
    }
  }

  prevStep = () => {
    if (this.state.currentStep > 1) {
      this.setState({ currentStep: this.state.currentStep - 1 })
    }
  }

  handleElementSelection = (newSelectedElements) => {
    this.setState({ selectedElements: newSelectedElements })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    
    // Transform inspection column IDs from $inspections_X to inspections_X format
    const transformedColumns = this.state.selected_columns.map(columnId => {
      if (columnId.startsWith('$inspections_')) {
        return columnId.replace('$inspections_', 'inspections_')
      }
      return columnId
    })
    
    this.props.mutate({
      variables: {
        type: 'WlWelds::Jobs::FinalReport',
        project_id: this.props.projectId,
        args: JSON.stringify({
          version: this.state.version,
          format: this.state.format,
          columns: transformedColumns,
          attachments: this.state.selected_attachments,
          selected_elements: this.state.selectedElements.map(id => parseInt(id, 10)),
          exclusions: this.state.selected_exclusions
        })
      }
    }).then(() => {
      this.props.client.query({
        query: GET_JOBS,
        fetchPolicy: 'network-only'
      }).then(({ data }) => {
        const notifyCount = data.user_jobs ? data.user_jobs.filter(job => job.notify).length : 0
        const event = new CustomEvent('changeNotifyCountInApp', { detail: { notifyCount } })
        window.dispatchEvent(event)
      })
      this.saveTemplates()
      this.props.toggleFunction()
    })
  }

  saveTemplates = () => {
    if (this.state.template_name) {
      let newTemplates = JSON.parse(localStorage.getItem('finalReportTemplates')) || {}
      _.set(newTemplates, `${this.state.version}.${this.state.template_name}`, this.state.selected_columns)
      localStorage.setItem('finalReportTemplates', JSON.stringify(newTemplates))
    }
  }

  removeTemplate = (name) => {
    let newTemplates = JSON.parse(localStorage.getItem('finalReportTemplates'))
    _.unset(newTemplates, `${this.state.version}.${name}`)
    localStorage.setItem('finalReportTemplates', JSON.stringify(newTemplates))
    this.setState({templates: newTemplates})
  }

  handleSelectedChange = (selected, selected_type) => {
    let new_selected = this.state[selected_type]
    const index = new_selected.indexOf(selected)
    if (index < 0) {
      new_selected.push(selected)
    } else {
      new_selected.splice(index, 1)
    }
    this.setState({[selected_type]: new_selected})
  }

  renderTemplatesList = () => {
    let templates = JSON.parse(localStorage.getItem('finalReportTemplates')) || {}
    return (
      <div>
        <h6>Templates:</h6>
        <Row>
          {templates[this.state.version] && Object.keys(templates[this.state.version]).map((template_name, i) => (
            <ButtonGroup key={i} style={{paddingLeft: '15px', paddingBottom: '5px'}}>
              <Button outline key={template_name} color="primary" size="sm"
                onClick={() =>
                  this.setState({
                    selected_columns: this.state.templates[this.state.version][template_name],
                    template_name: template_name
                  })
                }>
                {template_name}
              </Button>
              <Button key={`${template_name}_destroy`} size="sm" color="danger"
                onClick={() => this.removeTemplate(template_name)}>
                <i className="fa fa-sm fa-trash-o"/>
              </Button>
            </ButtonGroup>
          ))}
        </Row>
      </div>
    )
  }

  renderStep2 = () => {
    return (
      <Form>
        <Step2ColumnSelection 
          projectId={this.props.projectId}
          reportVersion={this.state.version}
          selectedColumns={this.state.selected_columns}
          onSelectedColumnsChange={this.handleSelectedChange}
        />

      </Form>
    )
  }

  render() {
    const { currentStep } = this.state
    
    return (
      <div>
        <Modal id="final-report-modal" isOpen={true} className="modal-primary" size="lg">
          <ModalHeader>
            Final Report - Step {currentStep} of 3
            {currentStep === 1 && ': Select Elements'}
            {currentStep === 2 && ': Columns'}
            {currentStep === 3 && ': Report Settings'}
          </ModalHeader>
          <ModalBody>
            {currentStep === 1 && (
              <Step1ElementSelection
                projectId={this.props.projectId}
                selectedElements={this.state.selectedElements}
                onSelectionChange={this.handleElementSelection}
              />
            )}
            {currentStep === 2 && this.renderStep2()}
            {currentStep === 3 && (
              <Step3ReportSettings
                versions={this.state.versions}
                version={this.state.version}
                format={this.state.format}
                selected_exclusions={this.state.selected_exclusions}
                selected_attachments={this.state.selected_attachments}
                onFormatChange={(e) => this.setState({ format: e.target.value })}
                onSelectedChange={this.handleSelectedChange}
              />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.props.toggleFunction}>Cancel</Button>
            {currentStep > 1 && (
              <Button color="secondary" onClick={this.prevStep}>Previous</Button>
            )}
            {currentStep < 3 ? (
              <Button 
                color="primary" 
                onClick={this.nextStep}
                disabled={currentStep === 1 && this.state.selectedElements.length === 0}
              >
                Next
              </Button>
            ) : (
              <Button 
                id="generate-raport-btn" 
                color="primary" 
                onClick={this.handleSubmit}
              >
                Generate
              </Button>
            )}
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

const FinalReportWithMutation = graphql(CreateFinalReport)(FinalReportModal)

export default withApollo(FinalReportWithMutation)


// WEBPACK FOOTER //
// ./src/components/FinalReport/FinalReportModal.js